<div id="eloViewSync-main-wraper">
  <div class="col-12 search-ft p-0 mt-3">
   <div class="row">
     <div class="col d-flex align-items-start p-0">
       <div class="form-group p-2 ml-2">
         <select name="ddfilter" class="form-control" (change)="eloViewFilterSelectChanged($event)" tabindex="1">
           <option *ngFor="let type of searchFilter" [value]="type.id"
             [selected]="type.id === eloViewFilterSelectedId">
             {{ type.name }}
           </option>
         </select>
       </div>

       <div class="form-group p-2">
         <input type="text" class="form-control" name="txtEloViewSearch" [(ngModel)]="txtEloViewSearch" maxlength="64"
           tabindex="2" (keydown.enter)="onEloViewSearch()" />
       </div>
       <div class="form-group p-2" *ngIf="hasMultipleSerNum">
         <select name="ddEloSerNumber" class="form-control" (change)="eloSerNumberChanged($event)"
           [(ngModel)]="selEloViewSerialnumber">
           <option *ngFor="let type of eloViewSerialnumbers" [selected]="type.id === selEloViewSerialnumber">
             {{type}}
           </option>
         </select>
       </div>
       <div class="col d-flex align-items-start btnAlign">
       <div class="form-group">
         <button class="btn btn-primary mr-2" name="btnGWSearch" (click)="getEloViewInfo()" tabindex="3">
           Search
         </button>
         <button class="btn btn-outline-primary mr-2" name="btnGWReset" (click)="resetFilters()" tabindex="4">
           Reset
         </button>
       </div>
     </div>
     </div>
     
   </div>
 </div>
  <div class="col d-flex align-items-center p-0 mb-1">
    <div class="form-group buttonAlignments mb-0">
      <input type="checkbox" class="cuscheckbox" name="checkBuilding" tabindex="5" [(ngModel)]="checkBuilding">&nbsp;
      <label name="lblGWUnitNum1" class="control-label mb-0">Building Name:&nbsp;</label>{{buildingName}}
    </div>
    <div class="ml-auto com-btn-test">
      <button class="btn btn-sync-primary" name="btnDigiSync" [disabled]="!buildingName" tabindex="6"
        (click)="SyncEloViewInfo()">
        <em class="fas fa-sync-alt"></em> FC to EloView Sync
      </button>
    </div>
  </div>
  <ag-grid-angular [enableCellTextSelection]="true" class="ag-theme-material elo-sync-layout" [rowData]="rowData"
    [columnDefs]="columnDefs" [gridOptions]="gridOptions">
  </ag-grid-angular>
</div>